<template>
    <v-navigation-drawer expand-on-hover app clipped mobile-break-point="0">
        <v-list-item v-if="title">
            <v-list-item-avatar tile size="24">
                <slot name="img">
                    <img src="@/assets/employee-interview-primary.svg" alt="Mitarbeiter-Gespräche"/>
                </slot>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle class="primary--text">
                    {{title}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-divider v-if="title">
        </v-divider>
        <slot name="list"></slot>
    </v-navigation-drawer>
</template>

<script>
    export default {
        props: ['src', 'title'],
        name: "app-layout-navbar-drawer"
    }
</script>

<style scoped>

</style>